export default (children, fn) =>
  typeof children === 'function'
    ? (...args) => fn(children(...args))
    : fn(children);
